import Styles from '../styles.module.scss';
import leftPic from '../../../../assets/brokers/pic-left-3-section.svg';
import rightPic from '../../../../assets/brokers/pic-right-3-section.svg';

const BrokersBecomeSection = () => (
  <div className={Styles['brokers-become-section']}>
    <div className={Styles.section}>
      <h2>Become a One Stop Destination For Clients</h2>
      <div className={Styles['flex-wrapper']}>
        <div className={Styles.column}>
          <div className={Styles['flex-wrapper']}>
            <p>Provide all the pre-purchase and portfolio management content that they need</p>
            <img src={leftPic} alt="" />
          </div>
        </div>
        <div className={Styles.column}>
          <div className={Styles['flex-wrapper']}>
            <p>Keep them within your site and increase your average revenue per user (ARPU)</p>
            <img src={rightPic} alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BrokersBecomeSection;
